
import SuggestedProducts from '@/graphql/queries/product/SuggestedProducts'

export default {
  props: {
    variables: {
      type: Object,
      default: null
    }
  },
  async fetch() {
    const { data } = await this.$graphql.query({
      clientId: 'eshop',
      query: SuggestedProducts,
      collection: true,
      variables: {
        first: 8,
        ...this.variables
      }
    })

    this.products = data
  },
  watch: {
    variables: {
      deep: true,
      immediate: true,
      handler: '$fetch'
    }
  },
  data() {
    return {
      products: []
    }
  }
}
